import type { RouterOutputs } from "@repo/api";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import type { PartialWithRequired } from "~/types";
import { ButtonContext } from "~/hooks/use-button";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";

export type Button = RouterOutputs["button"]["getAll"][number];

export type PartialButton = PartialWithRequired<
  Button,
  "position" | "location" | "mobile"
>;

interface ButtonProviderProps {
  children: ReactNode;
}

export const ButtonProvider = ({ children }: ButtonProviderProps) => {
  const { data: buttons, isFetching: isButtonsLoading } =
    api.button.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isButtonsLoading) {
      setLoadingStage("buttons");
    } else {
      setLoadingStage(undefined);
    }
  }, [isButtonsLoading, setLoadingStage]);

  const context = {
    buttons,
  };

  return (
    <ButtonContext.Provider value={context}>{children}</ButtonContext.Provider>
  );
};
